import { FC } from "react";
import { Stack } from "@mui/material";
import type { GridApi } from "ag-grid-community";
import { ResourceExplorerBreadcrumbs } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/resource-explorer-breadcrumbs/ResourceExplorerBreadcrumbs";
import { ResourceExplorerDataGridViewTabs } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/billing-explorer-data-grid/components/column-view-tabs/ResourceExplorerDataGridViewTabs";
import { ResourceExplorerCsvDownloader } from "@/components/pages/resource-explorer/components/resource-explorer-card/components/billing-explorer-data-grid/components/csv/ResourceExplorerCSVDownloader";
import { AGGridColumnsToolPanel } from "@/components/pages/common/ag-grid/components/AGGridColumnsToolPanel";
import { AgGridGlobalSearch } from "@/components/pages/common/ag-grid/components/global-search/AgGridGlobalSearch";
import { ResourceExplorerDataGridView } from "@/store/resource-explorer/utils/types/resourceExplorerDataGrid";

interface BillingExplorerGirdToolbarProps {
  gridApi: GridApi | null;
  dataGridView: ResourceExplorerDataGridView | null;
}

export const BillingExplorerGirdToolbar: FC<
  BillingExplorerGirdToolbarProps
> = ({ gridApi, dataGridView }) => {
  return (
    <Stack direction="row" justifyContent="space-between" spacing={3} px={1}>
      <Stack direction="row" paddingY={2} alignItems="center" overflow="hidden">
        <ResourceExplorerBreadcrumbs />
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1}>
        <AgGridGlobalSearch gridApi={gridApi} />

        <ResourceExplorerDataGridViewTabs />

        <ResourceExplorerCsvDownloader trigger="button" />

        <AGGridColumnsToolPanel
          disabled={dataGridView === "granular"}
          gridApi={gridApi}
        />
      </Stack>
    </Stack>
  );
};
